module.exports = global["Koala"] = require("-!C:\\MazdaNZ\\koala\\koala-frontend\\node_modules\\babel-loader\\lib\\index.js??ref--5!.\\koala.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?Koala!./src/containers/app/koala.js-exposed
// module id = 935
// module chunks = 0 1